import { IComponentOptions, IController } from 'angular';
import { IVesselSectionsRes, ISectionVesselJob, ISectionVesselType } from '../../../../../core/services/job-rank/job-rank.interfaces';
import { GmcFilterTypes } from '../../gmc-cv-filter-types';
import cloneDeep from 'lodash-es/cloneDeep';
import './section-filter.component.scss';

class SectionFilterController implements IController {
  static $inject = [];
  _sections: IVesselSectionsRes[];
  currentSection: IVesselSectionsRes;
  _currentVesselType: ISectionVesselType;
  selectedVessels: ISectionVesselJob[] = [];
  filterType: GmcFilterTypes;
  multiple: boolean;

  constructor() {
  }

  $onInit() {
  }

  set sections( data: IVesselSectionsRes[] ) {
    this._sections = cloneDeep(data);
    if ( !this.currentSection ) {
      this.currentSection = this._sections[ 0 ];
    }
  }

  get sections() {
    return this._sections;
  }

  set currentVesselType( type: ISectionVesselType ) {
    if ( type !== this._currentVesselType ) {
      this._currentVesselType = type;
      this.selectedVessels = [];
    }
  }

  get currentVesselType(): ISectionVesselType {
    return this._currentVesselType;
  }

  isJobChecked( vesselType: ISectionVesselType ): boolean {
    return this.selectedVessels.indexOf(vesselType) >= 0;
  }

  selectTab( section: IVesselSectionsRes ) {
    this.currentSection = section;
    this.currentVesselType = section.vessel_types[ 0 ];
  }

  toggleSelectedVessel( vessel: ISectionVesselJob ) {
    const index = this.selectedVessels.indexOf(vessel);
    if ( index > -1 ) {
      this.selectedVessels.splice(index, 1);
    } else {
      this.selectedVessels.push(vessel);
    }
  }
}

export const SectionFilterComponent: IComponentOptions = {
  controller: SectionFilterController,
  template: require('./section-filter.component.html'),
  bindings: {
    sections: '<',
    currentSection: '<?',
    selectedVessels: '=?',
    multiple: '<'
  }
};



// WEBPACK FOOTER //
// ./app/shared/components/gmc-cv-filter/components/section-filter/section-filter.component.ts